import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isPathbuddyHost } from '../../config/eduHost';
import { withAppBasename } from '../../config/appBase';
import './EduSiteHeader.css';

export default function EduSiteHeader({ onStartFree }) {
  const [navOpen, setNavOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const onPathbuddy = isPathbuddyHost();
  const onHome = location.pathname === '/';

  const closeNav = () => setNavOpen(false);

  const goHomeSection = (sectionId) => {
    closeNav();
    if (onHome) {
      if (!sectionId || sectionId === 'edu-landing-top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (!sectionId || sectionId === 'edu-landing-top') {
      navigate('/');
      return;
    }
    navigate({ pathname: '/', hash: sectionId });
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    goHomeSection(targetId);
  };

  const handleStartFreeClick = (e) => {
    e.preventDefault();
    closeNav();
    if (onStartFree) {
      onStartFree();
      return;
    }
    navigate('/login?signup=true', { state: { returnTo: '/chat' } });
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    closeNav();
    navigate('/login');
  };

  return (
    <header className="edu-landing-header">
      <div className="edu-landing-header-inner">
        <a
          className="edu-landing-logo"
          href={withAppBasename('/')}
          onClick={(e) => handleNavClick(e, 'edu-landing-top')}
        >
          {onPathbuddy ? (
            'Pathbuddy'
          ) : (
            <>
              IVORI <span>Edu</span>
            </>
          )}
        </a>
        <nav
          id="edu-landing-site-nav"
          className={`edu-landing-nav ${navOpen ? 'edu-landing-open' : ''}`}
        >
          <a
            href={withAppBasename('/')}
            className={onHome ? 'edu-landing-active' : undefined}
            onClick={(e) => handleNavClick(e, 'edu-landing-top')}
          >
            Home
          </a>
          <a href={withAppBasename('/#edu-landing-deck')} onClick={(e) => handleNavClick(e, 'edu-landing-deck')}>
            Product
          </a>
          <a href={withAppBasename('/#edu-landing-apps')} onClick={(e) => handleNavClick(e, 'edu-landing-apps')}>
            Apps
          </a>
          <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer" onClick={closeNav}>
            Lab
          </a>
          <a className="edu-landing-nav-login" href={withAppBasename('/login')} onClick={handleLoginClick}>
            Log in
          </a>
          <a className="edu-landing-nav-cta" href={withAppBasename('/login?signup=true')} onClick={handleStartFreeClick}>
            Start free
          </a>
        </nav>
        <button
          type="button"
          className="edu-landing-nav-toggle"
          aria-label="Toggle menu"
          aria-controls="edu-landing-site-nav"
          aria-expanded={navOpen}
          onClick={() => setNavOpen((open) => !open)}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </svg>
        </button>
      </div>
    </header>
  );
}
